(function($) {
  /* eslint-disable */
    var adminbar = $('#wp-admin-bar-root-default');
    if (adminbar.length) {
        adminbar.append( "<li id='wp-admin-bar-show-anchors'>Anchors</li>" );
        var bodyclass = $('body');
        var showanchors = $('#wp-admin-bar-show-anchors');

        // If click on admin bar 'anchor' All achors will be shown
        $(showanchors).click(function(){
            if( !bodyclass.hasClass('anchors--are--active') ) {
                $('.custom-anchorpoints').each(function(){
                    var id = $(this).attr('id');
                    $(this).html('<span class="custom-anchorpoints--value">#' + id + '</span>');
                });
                bodyclass.addClass('anchors--are--active');
            } else {
                bodyclass.removeClass('anchors--are--active');
            }
        });

        //check for doube id's and give a warning
        $('.custom-anchorpoints').each(function(){
            var ids = $('[id="'+this.id+'"]');
            if(ids.length>1 && ids[0]==this) {
                showanchors.append('<span style="color:red;"> Warning: Duplicate IDs #' + this.id + '</span>');
            }
        });

    }

    // Add smooth scrolling to all links
    $("a").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "" && !$(this).hasClass("TermNav-link")) {
					if ( this.href.indexOf( window.location.hostname ) != -1 ) {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
					}
        } // End if
    });
    /* eslint-enable */
})(jQuery)
